import React from "react";

import IconButton from "@material-ui/core/IconButton";

import IconMenu from "@material-ui/icons/Menu";
import IconBlurOn from "@material-ui/icons/BlurOn";
import IconAccountCircle from "@material-ui/icons/AccountCircle";

import logo from "assets/img/admin/logo.png";

import Menu from "./NavBarMenu";

export default ({ toggleSideNav }: { toggleSideNav: () => void }) => {
  return (
    <div className="navbar d-flex flex-wrap align-items-center justify-content-between">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center">
          <div className="logo d-none d-md-inline">
            <h3 className="m-0">
              <img src={logo} alt="logo" style={{ height: "54px" }} />
            </h3>
          </div>
          <div className="bars">
            <IconButton onClick={toggleSideNav}>
              <IconMenu htmlColor="white" />
            </IconButton>
          </div>
          <Menu
            icon={<IconBlurOn htmlColor="white" />}
            items={[
              {
                name: "Application",
                items: [
                  {
                    name: "Active list",
                    link: "/application/list/active"
                  },
                  {
                    name: "Archived list",
                    link: "/application/list/archived"
                  }
                ]
              },
              {
                name: "Prize",
                items: [
                  {
                    name: "Prize list",
                    link: "/prize/list"
                  },
                  {
                    name: "Category list",
                    link: "/prize/category/list"
                  },
                  {
                    name: "Supplier list",
                    link: "/prize/supplier/list"
                  },
                  {
                    name: "Order list",
                    link: "/prize/order/list"
                  }
                ]
              },
              {
                name: "Packages",
                disabled: true
              },
              {
                name: "Payments",
                disabled: true
              }
            ]}
          />
        </div>
        <div className="d-flex">
          <Menu
            icon={<IconAccountCircle htmlColor="white" />}
            items={[
              {
                name: "User profile",
                disabled: true
              },
              {
                name: "FAQ",
                disabled: true
              },
              {
                name: "Logout",
                disabled: true
              }
            ]}
          />
        </div>
      </div>
    </div>
  );
};
